export const serviceBaseURL = "/externo-portal-backend/v1";
export const backendBaseURL = "/externo-portal-backend"
